module.exports = __webpack_public_path__ + "media/application/images/2018/star-green-8ca1152bbbce4980df159268dc245cc6.svg";